import { Page } from '@/core/architecture'

import { ArtistMembershipFavoriteMembersSelectTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistMembershipFavoriteMembersSelect Page
 * Implemented as a practical sample.
 */
export const ArtistMembershipFavoriteMembersSelect: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ArtistMembershipFavoriteMembersSelectTemplate state={state} {...actions} />
  )
}
